import { Injectable, Sanitizer, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})
export class SanitizeService {

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  public sanitizeURL(url: string) {
    return this.sanitizer.sanitize(SecurityContext.URL, url);
  }

  public sanitizeBase64Image(base64Img: string) {
    return this.sanitizer.sanitize(SecurityContext.URL, `data:image/png;base64,${base64Img}`);
  }

  public sanitizeHTML(html: string) {
    return this.sanitizer.sanitize(SecurityContext.HTML, html);
  }

  /**
   * Remove or change the Font styles setting with empty string or the tag equivalent value.
   * @param content Note content
   * @returns A clean copy of the content without font style, font family, font size or font weight
   */
  public sanitizeNoteContent(content: string): string {
    const FONT_SIZE = /font-size:\s?(\w|\.)*;/g;
    const FONT_FAMILY = /font-family:\s?(\w|-|,|\s)*;/g;
    const CLASS_ATTR = /class="(\w|-)*"/g;
    const WHITE_SPACE_STYLE = /white-space:(\s?)(\w|-)*;/g;
    const FONT_WEIGHT = /<span(.*?)style="(.*?)font-weight:(\s?)bold;(.*?)"(.*?)>(.*?)<\/span>/g;
    const FONT_STYLE = /<span(.*?)style="(.*?)font-style:(\s?)italic;(.*?)"(.*?)>(.*?)<\/span>/g;
    const STRONG = '<span$1style="$2 $4"$5><strong>$6</strong></span>';
    const ITALIC = '<span$1style="$2 $4"$5><em>$6</em></span>';

    if (!content) {
      return null;
    }
    return content.replace(FONT_SIZE, '').replace(FONT_FAMILY, '').replace(CLASS_ATTR, '').replace(WHITE_SPACE_STYLE, '')
          .replace(FONT_WEIGHT, STRONG).replace(FONT_STYLE, ITALIC);
  }
}
